/** Address lookup only: never treats a provider's search result as verified geography. */
export function addressMapURL(address: {
  street: string;
  number: string;
  neighborhood: string;
}) {
  const query = [
    address.street,
    address.number,
    address.neighborhood,
    "Barueri",
    "SP",
    "Brasil",
  ]
    .filter(Boolean)
    .join(", ");
  return (
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent(query)
  );
}
